import React, { useEffect, useState } from 'react';

import SearchGuest from '@components/ui/search/SearchGuest/SearchGuest';
import {
  KidInterface,
  ListingSearchRoomInterface,
} from '@components/ui/search/SearchGuest/ListingSearchGuestInterface';
import ResponsiveListingSearchGuest, {
  validRoomChildAge,
} from '@components/views/hotel/listing/components/ResponsiveSearch/ResponsiveListingSearchGuest';
import { useDevice } from '@contexts/device';
import { generateUUID } from '@utils/generateUUID';

import { validateGuestsChildrenAges } from './bookerUtils';
import {
  ResponsiveListingSearchContainer,
  ResponsiveSearchDrawerItemContainer,
} from './styled';

type Props = {
  onApply: (hotelRooms: ListingSearchRoomInterface[]) => void;
  hotelRooms: Array<ListingSearchRoomInterface>;
  setHotelRooms: React.Dispatch<
    React.SetStateAction<Array<ListingSearchRoomInterface>>
  >;
  isBookerSearch?: boolean;
  disableAddRoomButton?: boolean;
  maxAdultCount?: number;
};

export const BookerGuestListingContainer = ({
  onApply,
  hotelRooms,
  setHotelRooms,
  isBookerSearch,
  disableAddRoomButton = false,
  maxAdultCount = 6,
}: Props) => {
  const [isShowSearchListingGuest, setIsSHowSearchListingGuest] =
    useState(false);

  const { isDesktop } = useDevice();

  const addNewRoom = (): void => {
    setHotelRooms([
      ...hotelRooms,
      {
        id: generateUUID(),
        adultCount: 2,
        childrenList: [],
        title: `${hotelRooms.length + 1}. Oda`,
        closable: true,
        error: false,
        key: String(hotelRooms.length + 1),
        ref: React.createRef<HTMLDivElement>(),
      },
    ]);
  };

  const apply = () => {
    const isError = validateGuestsChildrenAges(hotelRooms);

    if (isError) {
      handleChildError();
    }

    if (isError) return;

    onApply(hotelRooms);
    setHotelRooms(hotelRooms);
  };

  useEffect(() => {
    setHotelRooms(hotelRooms);
    onApply(hotelRooms);
  }, [hotelRooms]);

  // ============================================================
  // -Custom functions to control the children error
  // -using this function we can find an invalid child age and update te error property
  // =============================================================
  const handleChildError = (): void => {
    setHotelRooms((hr) =>
      hr?.map((room) =>
        room?.childrenList?.length !== 0
          ? {
              ...room,
              childrenList:
                room.childrenList &&
                room.childrenList.map((kid: KidInterface) =>
                  validRoomChildAge(String(kid.age))
                    ? { ...kid, error: false }
                    : { ...kid, error: true }
                ),
            }
          : room
      )
    );
  };

  const handleHideMobileGuestModal = () => {
    if (!validateGuestsChildrenAges(hotelRooms)) {
      setHotelRooms(hotelRooms);
      setIsSHowSearchListingGuest(false);
    } else {
      handleChildError();
    }
  };

  return !isDesktop ? (
    <ResponsiveListingSearchContainer>
      <ResponsiveListingSearchGuest
        showGuestModal={() => {
          setIsSHowSearchListingGuest(true);
        }}
        hideGuestModal={handleHideMobileGuestModal}
        width='100%'
        height='100%'
        placement='top'
        visible={isShowSearchListingGuest}
        rooms={hotelRooms}
        handleChildError={handleChildError}
        handleUpdateFinalRooms={apply}
        addNewRoom={addNewRoom}
        onHotelRoomsUpdate={(hr) => setHotelRooms(hr)}
        layout={1}
        finialRooms={hotelRooms}
        disableAddRoomButton={disableAddRoomButton}
        maxAdultCount={maxAdultCount}
      />
    </ResponsiveListingSearchContainer>
  ) : (
    <ResponsiveSearchDrawerItemContainer isBookerSearch={isBookerSearch}>
      <SearchGuest
        rooms={hotelRooms}
        setHotelRooms={setHotelRooms}
        popoverStyles={{ width: '570px', marginTop: '-10px' }}
        isBookerSearch={isBookerSearch}
        disableAddRoomButton={disableAddRoomButton}
        maxAdultCount={maxAdultCount}
      />
    </ResponsiveSearchDrawerItemContainer>
  );
};
export default BookerGuestListingContainer;
